export enum LinkTitle {
  ANSWER_BASE_QUESTION = "Answer base question",
  ANSWER_REFLEXIVE_QUESTION = "Answer reflexive question",
}

export interface Link {
  deprecation?: string;
  href?: string;
  hreflang?: string;
  media?: string;
  rel?: string;
  templated?: boolean;
  title?: string;
  type?: string;
}
